import { createArrayWithBracesParser } from '../inboundParsers';
import { trimBraces } from '../inboundUtils';
export const UPDATE_PLAYERS_PAYLOAD_DEFINITION = {
    shouldSplitWithBraces: true,
    definitionParts: [{ name: 'playersToUpdate', parser: createArrayWithBracesParser(playerToUpdateParser) }]
};
function playerToUpdateParser(str) {
    const parts = trimBraces(str).split(',');
    const [playerIdStr, numChipsStr, numChipsInBankStr, numBuyinsStr, levelStr, numPointsStr] = parts;
    return {
        playerId: Number(playerIdStr),
        numChips: Number(numChipsStr),
        numChipsInBank: Number(numChipsInBankStr),
        numBuyins: Number(numBuyinsStr),
        level: Number(levelStr),
        numPoints: numPointsStr !== '' ? Number(numPointsStr) : undefined // points can be omitted from the server side
    };
}
